import React from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

interface CounterFilterContainerProps {
  title: string;
  count: number;
  setCount: (value: string) => void;
}

const CounterFilterContainer = ({
  title,
  count,
  setCount,
}: CounterFilterContainerProps) => {
  const handleIncrement = () => {
    const increment = count + 1
    setCount(increment?.toString());
  };

  const handleDecrement = () => {
    if (+count > 0) {
      const decrement = count - 1
      setCount(decrement?.toString());
    }
  };

  const onChangeCount = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCount(event?.target?.value);
  }
  return (
    <Box>
      <Accordion sx={{ boxShadow: 'none' }} defaultExpanded={true}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          
        >
          <Typography
            sx={{ fontSize: "14px", fontWeight: "400", color: "#000000" }}
          >
            {title}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Stack direction="row" spacing={ 4 }>
            <TextField
              inputProps={{
                inputMode: "numeric",
                style: {
                    height: '40px',
                    padding: '0px 12px',
                    border: "1px solid #242629",
                    textAlign: 'center',
                    color: '#6C717A',
                }
              }}
              value={count}
              onChange={onChangeCount}
              sx={{
                borderRadius: "4px",
                marginBottom: "12px",
                width: "100%",
                height: '40px',
                padding: '0px',
                color: "#6C717A",
              }}
              variant="outlined"
            />
            <Button
              disabled={+count === 0}
              onClick={handleDecrement}
              variant="outlined"
              sx={{ height: '40px', borderRadius: '4px', minWidth: '35px !important', fontSize: '18px' }}
            >
              -
            </Button>
            <Button sx={{ height: '40px', borderRadius: '4px', minWidth: '35px !important', fontSize: '18px' }} variant="outlined" onClick={handleIncrement}>
              +
            </Button>
          </Stack>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default CounterFilterContainer;
